import { useRef, useState } from "react";
import { supabase } from "../supabase";
import Toast from "./Toast";
import { PiBookmarkSimpleFill, PiBookmarkSimpleBold } from "react-icons/pi";

// Controlled component — see LikeButton.jsx for why: the parent page owns
// `saved` (part of its `designs` state, from utils/myEngagement.js) instead
// of every SaveButton on screen tracking its own.
export default function SaveButton({ designId, saved, user, onUpdate }) {
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  // See LikeButton.jsx for why this ref exists alongside `loading`.
  const actionRef = useRef(false);

  async function handleSave() {
    if (!user) {
      setToast("Please log in to save");
      return;
    }

    if (loading || actionRef.current) return;
    actionRef.current = true;

    setLoading(true);

    // Atomic RPC — same reason as LikeButton's: two people saving the same
    // design at nearly the same moment used to both read the same starting
    // saved_by array, and the second write silently overwrote the first's
    // addition, dropping their save with no error or indication anywhere.
    const { data, error } = await supabase
      .rpc("toggle_design_save", { target_design_id: designId })
      .single();

    if (error) {
      console.log(error);
      setToast("Couldn't save. Try again.");
      setLoading(false);
      actionRef.current = false;
      return;
    }

    onUpdate?.({ _savedByMe: data.saved });
    setToast(data.saved ? "Saved" : "Removed from saved");
    setLoading(false);
    actionRef.current = false;
  }

  return (
    <>
      <button
        onClick={handleSave}
        disabled={loading}
        style={{
          ...btn,
          opacity: loading ? 0.6 : 1,
          color: "var(--text-primary)"
        }}
        aria-label={saved ? "Remove from saved" : "Save design"}
      >
        {saved ? <PiBookmarkSimpleFill size={27} /> : <PiBookmarkSimpleBold size={27} />}
      </button>

      {toast && <Toast text={toast} onClose={() => setToast("")} />}
    </>
  );
}

const btn = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  padding: 0,
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  background: "none",
  lineHeight: 1
};
